import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ProfessionalAthlete } from 'models/interfaces/professional-athlete.interface'
import { getProfessionalAthleteSelected, setProfessionalAthleteSelected } from 'storage/sessionProfessionAthlete'

const SummaryAthleteAction: string = 'SummaryAthlete'

interface InitialState {
  reload: boolean
  professionalAthlete: ProfessionalAthlete | null
}

const initialState: InitialState = {
  reload: false,
  professionalAthlete: getProfessionalAthleteSelected()
}

export const summaryAthleteSlice = createSlice({
  name: SummaryAthleteAction,
  initialState,
  reducers: {
    setSummaryProfessionalAthlete: (state, action: PayloadAction<ProfessionalAthlete>) => {
      state.professionalAthlete = action.payload
      setProfessionalAthleteSelected(action.payload)
      state.reload = !state.reload
    }
  }
})

export default summaryAthleteSlice.reducer
